module.exports = __webpack_public_path__ + "static/media/punchcard-solo.898487b0.glb";